'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXFilter = exports.VXFilterNote = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _core = require('@blueprintjs/core');

var _ = require('../../');

var _withFilter = require('./with-filter');

var _vxFilterContainer = require('../vx-filter-container');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledNote = _glamorous2.default.span({
  fontStyle: 'italic',
  color: _.Colors.GREY2
});

var VXFilterNote = exports.VXFilterNote = function VXFilterNote(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    StyledNote,
    null,
    children
  );
};

VXFilterNote.propTypes = {
  children: _propTypes2.default.node
};

var StyledTree = (0, _glamorous2.default)(_core.Tree)({
  paddingTop: 5
}, function (_ref2) {
  var _ref3;

  var isTree = _ref2.isTree,
      isRtl = _ref2.isRtl;
  return _ref3 = {
    '& .pt-tree-root': {
      paddingRight: isRtl ? 0 : null
    },
    '& .pt-collapse .pt-collapse-body > .pt-tree-node-list': {
      paddingRight: isRtl ? '0' : null
    },
    '& .pt-tree-node-content-1': {
      paddingRight: isRtl ? '23px' : null
    },
    '& .pt-tree-node-content-2': {
      paddingRight: isRtl ? '46px' : null
    },
    '& .pt-tree-node-content-3': {
      paddingRight: isRtl ? '69px' : null
    },
    '& .pt-tree-node-content-4': {
      paddingRight: isRtl ? '92px' : null
    },
    '& .pt-tree-node-content-5': {
      paddingRight: isRtl ? '115px' : null
    }
  }, _defineProperty(_ref3, '& .pt-tree-root', {
    paddingRight: isRtl ? 0 : null
  }), _defineProperty(_ref3, '& .pt-tree-node-content-0', {
    paddingLeft: isTree ? 0 : 10
  }), _defineProperty(_ref3, '& .pt-tree-node-caret-none', {
    minWidth: isTree ? 30 : 0
  }), _defineProperty(_ref3, '& .pt-tree-node-caret::before', {
    content: isRtl ? '"\\E694"' : '"\\E695"'
  }), _defineProperty(_ref3, '& .pt-tree-node-caret.pt-tree-node-caret-open::before', {
    transform: isRtl ? 'rotate(-90deg)' : 'rotate(90deg)'
  }), _ref3;
});

var Filter = function (_React$Component) {
  _inherits(Filter, _React$Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.VXFilterContainer = (0, _vxFilterContainer.VXFilterContainerHOC)(props.isOpenDry);
    return _this;
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          titleLabel = _props.titleLabel,
          isBlank = _props.isBlank,
          isTree = _props.isTree,
          isRtl = _props.isRtl,
          isOpen = _props.isOpen,
          changeIsOpen = _props.changeIsOpen,
          spotlight = _props.spotlight,
          onSpotlightChange = _props.onSpotlightChange,
          spotlightedContents = _props.spotlightedContents,
          onNodeExpand = _props.onNodeExpand,
          onNodeCollapse = _props.onNodeCollapse,
          onNodeClick = _props.onNodeClick;


      return _react2.default.createElement(
        this.VXFilterContainer,
        {
          titleLabel: titleLabel,
          isOpen: isOpen,
          isRtl: isRtl,
          changeIsOpen: changeIsOpen,
          isBlank: isBlank,
          topElement: _react2.default.createElement(_.VXSpotlight, _extends({}, spotlight, { changeSpotlight: onSpotlightChange, isRtl: isRtl }))
        },
        _react2.default.createElement(StyledTree, {
          isTree: isTree,
          isRtl: isRtl,
          contents: spotlightedContents,
          onNodeClick: onNodeClick,
          onNodeExpand: onNodeExpand,
          onNodeCollapse: onNodeCollapse
        })
      );
    }
  }]);

  return Filter;
}(_react2.default.Component);

Filter.propTypes = {
  titleLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  changeIsOpen: _propTypes2.default.func.isRequired,
  isOpen: _propTypes2.default.bool,
  isOpenDry: _propTypes2.default.bool,
  isBlank: _propTypes2.default.bool,
  isTree: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  spotlight: _propTypes2.default.object,
  onSpotlightChange: _propTypes2.default.func.isRequired,
  spotlightedContents: _propTypes2.default.array,
  onNodeClick: _propTypes2.default.func.isRequired,
  onNodeExpand: _propTypes2.default.func.isRequired,
  onNodeCollapse: _propTypes2.default.func.isRequired
};

var VXFilter = exports.VXFilter = (0, _withFilter.withFilter)(Filter);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filter/index.js
// module id = 2030
// module chunks = 0